import { Injectable } from '@angular/core';

@Injectable()
export class CmsPageTypes {
  code;

  constructor() {
    this.code = {
      TERMS_OF_USE: 'terms-of-use',
      PRIVACY_POLICY: 'privacy-policy',
      COOKIES: 'cookies',
      IMPRESSUM: 'impressum',
      REGISTRATION_AGREEMENT: 'registration-agreement',
      REGISTRATION_HARD_COPY_AGREEMENT: 'registration-hard-copy-agreement',
      //targetting the amamdeus +me terms and conditions path in magento
      REGISTRATION_LOYALTY_AGREEMENT: 'registration-amadeus-plus-me-agreement',
      LOYALTY_LICENCE_AGREEMENT: 'loyalty-licence-agreement'
    };
  }
}
